import React from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const statGridStyle: React.CSSProperties = {
  display: "grid",
  gap: "1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
};

export default function ProviderFinancePage() {
  const stats = [
    { label: "Gross earnings", value: "£0.00" },
    { label: "Deposits captured", value: "£0.00" },
    { label: "Commission due", value: "£0.00" },
    { label: "Reconciliation issues", value: "0" },
  ];

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Finance</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Track earnings, commissions, deposit outcomes, and reconciliation visibility from the provider side.
        </p>
      </section>

      <section style={statGridStyle}>
        {stats.map((stat) => (
          <div key={stat.label} style={cardStyle}>
            <div style={{ color: "#64748b", fontWeight: 600 }}>{stat.label}</div>
            <div style={{ marginTop: "0.55rem", fontSize: "1.8rem", fontWeight: 800, color: "#0f172a" }}>
              {stat.value}
            </div>
          </div>
        ))}
      </section>

      <section style={cardStyle}>
        <h3 style={{ margin: 0, color: "#0f172a" }}>Finance visibility</h3>
        <ul style={{ margin: "1rem 0 0", paddingLeft: "1.1rem", color: "#334155", lineHeight: 1.8 }}>
          <li>Payments summary by service and booking status.</li>
          <li>Deposit capture versus refunds or no-show outcomes.</li>
          <li>Commission and invoice review before settlement.</li>
          <li>Cash and online reconciliation checks.</li>
        </ul>
      </section>
    </div>
  );
}